import React, { useState, useContext, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { setPage, setValueSearchFilter, translate } from '../../../utils/Common';
import { useForm } from 'react-hook-form';
import AuthContext from '../../../contexts/auth';
import PageContainer from '../../../components/layout/PageContainer';
import PageHeader from '../../../components/layout/PageHeader';
import ContentCard from '../../../components/layout/ContentCard';
import * as FaIcons from 'react-icons/fa';
import ProviderList from '../../../components/ProviderList';
import PackagesReservation from '../../../components/PackagesReservation';
import ItemReserva from '../../../components/ShowItems/ItemReserva';
import { verifyAccessViewPermissions } from '../../../config/permissions';
import styles from './AwaitingDelivery.module.css';

const AwaitingDelivery = () => {
    const location = useLocation();
    const { register, watch, setValue } = useForm();
    const provider = useRef({});
    provider.current = watch('proveedor', '');
    const userContext = useContext(AuthContext);
    const canSearchCompany = verifyAccessViewPermissions(["search"], { path: location.pathname });

    const [updateTable, setUpdateTable] = useState(false);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [selectedUser, setSelectedUser] = useState(null);

    useEffect(() => {
        const handleUserChange = () => {
            setSelectedUser(selectedCompany ? Number(selectedCompany.IdUsuario) : 0);
            setUpdateTable(!updateTable);
        }
        handleUserChange();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [provider.current, selectedCompany]);

    useEffect(() => {
        setPage('');
        setValueSearchFilter('');
    }, []);

    return (
        <PageContainer>
            <PageHeader
                title={translate("dashboard.awaitingDelivery.title")}
                icon={<FaIcons.FaCar size={24} />}
            />

            {userContext.user?.IsAdmin && canSearchCompany && (
                <ContentCard padding="md">
                    <div className={styles.filterRow}>
                        <div className={styles.filterField}>
                            <label htmlFor="selectProveedorAwaiting" className={styles.filterLabel}>
                                <span className={styles.requiredMark}>*</span>
                                {translate("global.business")}:
                            </label>
                            <ProviderList
                                register={register}
                                nameShow={translate("global.select")}
                                idShow={"all"}
                                readOnly={false}
                                setValue={setValue}
                                valueId={"proveedor"}
                                setProveedor={setSelectedCompany}
                            />
                        </div>
                    </div>
                </ContentCard>
            )}

            <PackagesReservation
                selectedUser={selectedUser}
                updateTable={updateTable}
                handleUpdateTable={setUpdateTable}
                ItemComponent={ItemReserva}
                reservationType={2}
                canSearchCompany={canSearchCompany}
            />
        </PageContainer>
    );
};

export default AwaitingDelivery;
